import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Key } from "@phosphor-icons/react";

// Super-admin action to reset another user's password.
export const AdminResetPassword = ({ userId, userLabel, testid }) => {
  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (pw.length < 8) return toast.error("Password must be at least 8 characters.");
    setSaving(true);
    try {
      await api.post(`/admin/users/${userId}/reset-password`, { new_password: pw });
      toast.success("Password reset. Share the new password securely with the user.");
      setPw(""); setOpen(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <>
      <button data-testid={testid} onClick={() => setOpen(true)} className="inline-flex items-center gap-1 rounded-full border border-stone-200 px-2.5 py-1 text-xs font-medium text-stone-600 hover:bg-accent">
        <Key size={13} /> Reset password
      </button>
      <Dialog open={open} onOpenChange={(v) => { if (!v) setPw(""); setOpen(v); }}>
        <DialogContent data-testid="admin-reset-dialog">
          <DialogHeader><DialogTitle className="flex items-center gap-2 font-heading"><Key size={20} className="text-primary" /> Reset password</DialogTitle></DialogHeader>
          <div className="space-y-3 text-sm text-stone-600">
            <p>Set a new password for <strong className="text-stone-800">{userLabel}</strong>. They can change it later from their profile.</p>
            <div><Label>New password</Label><Input data-testid="admin-reset-input" type="text" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1 rounded-xl" placeholder="At least 8 characters" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" className="rounded-xl" onClick={() => { setPw(""); setOpen(false); }}>Cancel</Button>
            <Button data-testid="admin-reset-submit" disabled={saving || pw.length < 8} className="rounded-xl bg-primary hover:bg-green-900" onClick={submit}>{saving ? "Resetting…" : "Reset Password"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
